var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-img", {
        staticClass: "bkg_img",
        attrs: {
          fluid: "",
          src: require("@/assets/images/pages/graphic-3.png")
        }
      }),
      _c(
        "div",
        { attrs: { id: "_document-public" } },
        [
          _c(
            "b-card",
            {
              staticClass: "h-full",
              attrs: { "header-bg-variant": "primary" },
              scopedSlots: _vm._u([
                {
                  key: "header",
                  fn: function() {
                    return [
                      _c(
                        "span",
                        { staticClass: "p-0 text-white text-lg font-bold" },
                        [
                          _vm._v(
                            "SECURAMDATA - " +
                              _vm._s(
                                _vm.document.title
                                  ? _vm.document.title
                                  : "Documentos"
                              )
                          )
                        ]
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "footer",
                  fn: function() {
                    return [
                      _c("page-footer", {
                        attrs: { "text-label": "Entregue por" }
                      })
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _c("div", { staticClass: "pt-1" }, [
                _c("div", { staticClass: "flex flex-col gap-1" }, [
                  _c("div", { staticClass: "_row" }, [
                    _c("div", {
                      directives: [
                        {
                          name: "html-safe",
                          rawName: "v-html-safe",
                          value: _vm.document.description
                            ? _vm.document.description
                            : "",
                          expression:
                            "document.description? document.description: ''"
                        }
                      ],
                      staticClass: "simple-content simple-editor"
                    })
                  ]),
                  _vm.document.id
                    ? _c(
                        "div",
                        { staticClass: "_row" },
                        [
                          _c("h5", { staticClass: "mt-2 mb-0" }, [
                            _vm._v(_vm._s(_vm.$t("document_subtitle_document")))
                          ]),
                          _c("vs-divider"),
                          _c("media-list", {
                            attrs: {
                              medias: _vm.files,
                              "show-delete": false,
                              "action-on-click": false
                            }
                          }),
                          _vm.files || _vm.files.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass: "flex flex-row justify-end pb-1"
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "primary" },
                                      on: { click: _vm.downloadAll }
                                    },
                                    [
                                      _c("feather-icon", {
                                        staticClass: "mr-50",
                                        attrs: { icon: "DownloadIcon" }
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "align-middle" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("action.download_all")
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.files.length == 0 && _vm.document.id
                            ? _c(
                                "div",
                                { staticClass: "flex flex-row justify-center" },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("msg_none_file")) + " "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.accessByCode && !_vm.document.id
                    ? _c(
                        "div",
                        {
                          staticClass: "flex flex-row justify-center gap-4 mt-2"
                        },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary" },
                              on: { click: _vm.openViewPromptCodeValidate }
                            },
                            [_vm._v("Informar token de Acesso")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ])
            ]
          )
        ],
        1
      ),
      _c("b-modal", {
        attrs: {
          title: _vm.$t("document_validate_token"),
          "ok-disabled": !_vm.validAccessTokenRequired,
          "ok-only": "",
          id: "prompt-document-token"
        },
        on: {
          ok: function($event) {
            return _vm.validateAccessCodeAndGetDocument(_vm.evt)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c(
                  "b-form",
                  { ref: "inputPromptValidateCode" },
                  [
                    _c("span", { staticClass: "text-sm" }, [
                      _c("p", { staticClass: "text-justify" }, [
                        _vm._v(
                          " Por motivos de segurança, você deve inserir o Token (código) abaixo a fim de verificar sua permissão para acessar o(s) documento(s). O código funcionará somente por 30 minutos e, se você solicitar um novo código, esse código deixará de funcionar. "
                        )
                      ])
                    ]),
                    _c(
                      "validation-observer",
                      [
                        _c("validation-provider", {
                          staticClass: "flex-grow",
                          attrs: {
                            name: _vm.$t("Token"),
                            rules: "required|min:4",
                            slim: ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "input-group-1",
                                        label: _vm.$t("document_token"),
                                        "label-for": "document_token"
                                      }
                                    },
                                    [
                                      _c("b-form-input", {
                                        staticClass: "required",
                                        attrs: {
                                          id: "document_token",
                                          state:
                                            errors.length > 0 ? false : null,
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.access_code,
                                          callback: function($$v) {
                                            _vm.access_code = $$v
                                          },
                                          expression: "access_code"
                                        }
                                      }),
                                      _c(
                                        "b-form-invalid-feedback",
                                        { class: [{ absolute: _vm.inline }] },
                                        [_vm._v(" " + _vm._s(errors[0]) + " ")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    ),
                    _c("span", { staticClass: "text-sm" }, [
                      _c("p", { staticClass: "text-justify" }, [
                        _vm._v(
                          " O Token (código) é enviado automaticamente para o seu e-mail, ao acessar o link (endereço eletrônico) do documento compartilhado. "
                        )
                      ])
                    ])
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "modal-ok",
            fn: function() {
              return [_vm._v(" " + _vm._s(_vm.$t("action.confirm")) + " ")]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }